import { render, staticRenderFns } from "./USC_21_009.vue?vue&type=template&id=2f5d4a65&scoped=true"
import script from "./USC_21_009.vue?vue&type=script&lang=js"
export * from "./USC_21_009.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5d4a65",
  null
  
)

export default component.exports